<template>
	<div class="wholeList">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>整装整租</span>
			<div></div>
		</div>
		<div class="listNone" v-if="list.length == 0">暂无订单</div>
		<router-link :to="{name: 'wholeMsg', query: {number: v.order_number}}" v-for="(v,x) in list" :key="x" v-else>
			<div class="list">
				<img src="../../../assets/zhengzu.png" alt="">
				<div class="list-header">
					<span>{{v.create_time}}</span>
					<span v-if="v.state == 0">付款确认中</span>
					<span v-if="v.state == 1">已付款</span>
				</div>
				<div class="list-main">
					<div>
						<span> 月租金: ¥{{v.month_total}}/M²</span>&nbsp;&nbsp;<span>总价：</span><span class="totals">¥{{v.total}}</span><span
						 class="mortgage">(含可退押金¥{{v.mortgage_total}})</span>
					</div>
				</div>
				<div style="display: flex; justify-content: space-between;">
					<div class="list-foot">
						订单编号：{{v.order_number}}
					</div>
					<div class="list-foot" v-if="v.is_channel == 1">
						对公转账
					</div>
				</div>

			</div>
		</router-link>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: []
			}
		},
		created() {
			this.$axios.post(baseUrl + '/mobile/WholeOrder/wholeOrder', {
				token: localStorage.getItem('Authorization')
			}).then((res) => {
				if (res.data.code == 2) {
					this.list = res.data.data
				}
			}).catch((err) => {
				console.log(err);
			})
		},
		methods: {

		},
	}
</script>

<style scoped>
	.wholeList {
		text-align: left;
		padding: 2rem 0 1rem 0;
	}

	a {
		color: #333 !important;
	}

	.wholeList .list {
		background: #fff;
		position: relative;
		border-radius: 0.5rem;
		width: 94%;
		margin: 0 auto;
		margin-top: 1rem;
		font-size: 0.8rem;
		padding: 0.5rem 1rem;
		box-sizing: border-box;
	}

	.wholeList .list img {
		position: absolute;
		left: -0.5rem;
		top: -0.7rem;
		width: 2rem;
		height: 2rem;
	}

	.wholeList .list .list-header {
		padding-bottom: 0.5rem;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		text-indent: 1rem;
		font-weight: bold;
	}

	.wholeList .list .list-header span:nth-child(2) {
		color: #F1452F;
		font-weight: 100;
	}

	.wholeList .list .list-main {
		height: 3rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		border-top: 1px dashed #ccc;
		border-bottom: 1px dashed #ccc;
		padding: 0.7rem 0;
	}

	.wholeList .list .list-main .totals {
		font-size: 1rem;
		color: #F1452F;
	}

	.wholeList .list .list-main .mortgage {
		color: #999;
		margin-left: 0.5rem;
	}

	.wholeList .list .list-foot {
		padding-top: 0.5rem;
	}

	.wholeList .listNone {
		color: #8b8b8b;
		font-size: 0.8rem;
		margin-top: 3rem;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/home/whole/wholeList.vue